/**
 *
 * @description Permet de générer une photothéque dans des pages différentes
 */

/* global bsBreakpoints ModuloTS SwiperKiller $get keyboardNavigation */

(() => {
	let btnOpenGallery, btnOpenVideo;
	/**
	 *
	 * @description Gestion du boutton afficher plus de médias
	 */

	const showMorePhoto = () => {
		const photoNumber =
			document.getElementById('album__item').childElementCount;
		const currentBlockHeight =
			document.getElementById('album__item').offsetHeight;

		const moreMedia = (block, nPhoto) => {
			// Hauteur par default souhaitée
			let heightBlock = block;

			// Nombre de click pour obernir la hauteur max
			let nClick = Math.round(photoNumber / nPhoto);

			// Si y'a plus de photos que la hauteur peut posséder de photos
			if (photoNumber > nPhoto && currentBlockHeight > block) {
				if (
					document.querySelector('.show-more-media') === undefined ||
					document.querySelector('.show-more-media') === null
				) {
					document
						.querySelector('.album__item')
						.insertAdjacentHTML(
							'afterend',
							`<button class="show-more-media">${ModuloTS['Show more media']}</button>`
						);
				} else {
					document.querySelector('.show-more-media').remove();
					document
						.querySelector('.album__item')
						.insertAdjacentHTML(
							'afterend',
							`<button class="show-more-media">${ModuloTS['Show more media']}</button>`
						);
				}
				// init la hauteur du block
				document
					.querySelector('.album__item')
					.setAttribute('style', `height: ${heightBlock}px;`);

				const testClick = () => {
					if (nClick === 1) {
						document.querySelector('.show-more-media').remove();
						document
							.querySelector('.album__item')
							.setAttribute('style', `height: auto`);
					}
				};

				// Nombre de fois qu'on ajoute de la hauteur grâce au clique
				document
					.querySelector('.show-more-media')
					.addEventListener('click', () => {
						if (nClick !== 1) {
							heightBlock += block;
							document
								.querySelector('.album__item')
								.setAttribute(
									'style',
									`height: ${heightBlock}px;`
								);
							nClick -= 1;
							testClick();
						}
						testClick();
					});
			}
		};

		// Changement des breakpoints
		const moreMediaBreakpoint = () => {
			if (bsBreakpoints.detectBreakpoint() === 'xLarge') {
				moreMedia(795, 15);
			}
			if (bsBreakpoints.detectBreakpoint() === 'medium') {
				moreMedia(1590, 18);
			}
			if (bsBreakpoints.detectBreakpoint() === 'small') {
				moreMedia(1180, 8);
			}
			if (bsBreakpoints.detectBreakpoint() === 'xSmall') {
				moreMedia(1400, 5);
			}
		};

		moreMediaBreakpoint();

		// Changement des breakpoints au resize
		window.onresize = () => {
			moreMediaBreakpoint();
		};
	};

	/**
	 *
	 * @description Permet d'afficher un overlay noir avec une vidéo au clique d'un média vidéo
	 */
	const playerWindow = (button) => {
		document.querySelectorAll(button).forEach((player) => {
			player.addEventListener('click', () => {
				btnOpenVideo = player;
				document.querySelector('.album').scroll({
					top: 0,
					left: 0,
					behavior: 'smooth',
				});
				if (document.querySelector('.over-player-video') === null) {
					document.querySelector('.album-wrapper').insertAdjacentHTML(
						'afterbegin',
						`<div class="over-player-video">
                  <button aria-describedby='${player.getAttribute(
						'data-video-id'
					)}' class="over-player-video__close"><i data-icon="cross"></i>
				  	<span class="sr-only">Retour à la liste des médias</span>
				  </button>
				  
                </div>`
					);

					if (player.getAttribute('data-provider') === 'youtube') {
						// This code loads the IFrame Player API code asynchronously.
						const tag = document.createElement('script');

						tag.src = 'https://www.youtube.com/iframe_api';
						const firstScriptTag =
							document.getElementsByTagName('script')[0];
						firstScriptTag.parentNode.insertBefore(
							tag,
							firstScriptTag
						);
					}

					setTimeout(() => {
						if (
							player.getAttribute('data-provider') === 'youtube'
						) {
							const ytDiv = `<div id="videoyt"></div>`;

							document
								.querySelector('.over-player-video')
								.insertAdjacentHTML('beforeend', ytDiv);
							let playeryt;

							function onYouTubeIframeAPIReady() {
								playeryt = new YT.Player('videoyt', {
									height: '360',
									width: '640',
									videoId: player.getAttribute('data-id'),
									events: {
										// onReady: onPlayerReady,
										// onStateChange: onPlayerStateChange,
									},
								});
							}

							onYouTubeIframeAPIReady();
						} else {
							const iframe = `<iframe id="${player.getAttribute(
								'data-video-id'
							)}" title="${player.getAttribute(
								'data-video-description'
							)}" src="${player.getAttribute(
								'data-video-url'
							)}"</iframe>`;

							document
								.querySelector('.over-player-video')
								.insertAdjacentHTML('beforeend', iframe);
						}

						const goToClose =
							'<button class="go-to-close" aria-hidden="true"></button>';

						document
							.querySelector('.over-player-video')
							.insertAdjacentHTML('beforeend', goToClose);

						document
							.querySelector(
								'.over-player-video .over-player-video__close'
							)
							.focus();
						document.querySelector(
							'.over-player-video .over-player-video__close'
						);
						document
							.querySelector('.over-player-video')
							.addEventListener('keydown', (e) => {
								if (e.key === 'Tab') {
									e.target.parentNode
										.querySelector('iframe')
										.contentWindow.focus();
								}
							});

						document
							.querySelector('.go-to-close')
							.addEventListener('keyup', (e) => {
								if (e.key === 'Tab') {
									document
										.querySelector(
											'.over-player-video .over-player-video__close'
										)
										.focus();
								}
							});
					}, 800);
				}
				document
					.querySelector('.album')
					.classList.add('overflow-layout');
				document
					.querySelector(
						'.over-player-video .over-player-video__close'
					)
					.addEventListener('click', () => {
						document
							.querySelector('.over-player-video')
							.classList.add('slideDown');
						setTimeout(() => {
							document
								.querySelector('.over-player-video')
								.remove();
						}, 800);
						document
							.querySelector('.album')
							.classList.remove('overflow-layout');
						btnOpenVideo.focus();
					});

				// keyboardNavigation(
				// 	document.querySelector('.over-player-video')
				// );
			});
		});
	};

	/**
	 *
	 * @description Afficher nombre de medias au survol d'une tuile
	 */

	const photosNumber = (id) => {
		document.querySelectorAll('.gallery__item').forEach((el) => {
			const albumAtt = el.getAttribute(id);
			$get(`/phototheque/get/${albumAtt}?isPost=true`).then((data) => {
				if (data.galleryDataCount === 0) {
					el.querySelector('.gallery__item__link').insertAdjacentHTML(
						'beforeend',
						`<p class="gallery__item__count">${ModuloTS['No media']}</p>`
					);
				} else {
					el.querySelector('.gallery__item__link').insertAdjacentHTML(
						'beforeend',
						`<p class="gallery__item__count">${
							data.galleryDataCount
						} ${ModuloTS.media}${
							data.galleryDataCount > 1 ? 's' : ''
						}</p>`
					);
				}
			});
		});
	};

	const buttonCloseText = () => {
		let text;
		if (document.querySelectorAll('.image-gallery').length !== 0) {
			text = 'Revenir à la page';
		} else {
			text = 'Revenir aux albums';
		}
		return text;
	};

	const albumOff = () => {
		const btnGalleryClose = document.querySelectorAll(`[data-close]`);
		btnGalleryClose.forEach((btn) => {
			btn.addEventListener('click', () => {
				document
					.querySelector('body')
					.classList.remove('overflow-layout');
				if (
					btn.innerHTML ===
						`<i data-icon="arrow"></i> ${buttonCloseText()}` ||
					btn.innerHTML ===
						`<span class="sr-only">Retour à la liste des médias</span>
						<i data-icon="cross"></i>`
				) {
					// focus button open gallery
					if (btnOpenGallery.tagName === 'BUTTON') {
						btnOpenGallery.focus();
					} else {
						btnOpenGallery.querySelector('button').focus();
					}

					const album = document.getElementById('album-photo');
					album.classList.add('slideDown');
					setTimeout(() => {
						album.remove();
					}, 800);
				} else {
					document
						.querySelector('.album__close--cross')
						.classList.remove('album__close--cross-active');
					document.getElementById(
						'close-photo-button'
					).innerHTML = `<i data-icon="arrow"></i> ${buttonCloseText()}`;
					document
						.querySelector('.album__item')
						.classList.remove('hide-content', 'fadeDown');

					if (document.querySelector('.show-more-media') != null) {
						document
							.querySelector('.show-more-media')
							.classList.remove('hide-content');
					}

					document
						.querySelector('.album__item')
						.classList.add('fadeUp');
					keyboardNavigation(document.querySelector('#album-photo'));

					document
						.querySelector('.slider-count')
						.classList.add('hide-content');
					document.querySelector('[data-sk-index]').innerText = '';
				}
			});
		});
	};

	/**
	 * @description Gère le cas si l'élément suivant est une iframe
	 */
	const focusMediaPlayer = () => {
		const plyrMediaBtn =
			document.querySelector('.player-media-button') || null;
		const plyrMediaBtnSquare =
			document.querySelector('.player-media-button-square') || null;

		if (plyrMediaBtn) {
			plyrMediaBtn.addEventListener('keypress', (e) => {
				const isEnterPressed = e.key === 'Enter';
				let iframe;

				if (!isEnterPressed) {
					return;
				}

				setTimeout(() => {
					iframe = document.querySelector('iframe');
					iframe.contentWindow.focus();
				}, 100);
			});
		}

		if (plyrMediaBtnSquare) {
			plyrMediaBtnSquare.addEventListener('keypress', (event) => {
				const isEnterPressed = event.key === 'Enter';
				let otherIframe;

				if (!isEnterPressed) {
					return;
				}

				setTimeout(() => {
					otherIframe = document.querySelector('iframe');
					otherIframe.contentWindow.focus();
				}, 100);
			});
		}
	};

	focusMediaPlayer();

	const sliderFunctionCore = (button) => {
		const sliderIndex = button.getAttribute('data-id');

		document.getElementById(
			'close-photo-button'
		).innerHTML = `<span class="sr-only">Voir tous les médias</span>
			<i data-icon="arrow"></i> Voir tous les médias`;
		document.querySelector('.album__item').classList.remove('fadeUp');
		document.querySelector('.album__item').classList.add('fadeDown');
		document
			.querySelector('.album__close--cross')
			.classList.add('album__close--cross-active');

		setTimeout(() => {
			const showMoreBtn = document.querySelector('.show-more-media');
			document
				.querySelector('.album__item')
				.classList.add('hide-content');
			document
				.querySelector('.slider-count')
				.classList.remove('hide-content');
			if (showMoreBtn != null) {
				showMoreBtn.classList.add('hide-content');
				showMoreBtn.tabindex = -1;
			}

			// ShowCurrentDesc();
			playerWindow('.player-media-button-square');
			// Homemade Slider called global/js/swiperKiller.js

			const photoNumber =
				document.getElementById('album__item').childElementCount;

			if (photoNumber > 1) {
				const slideMedia = new SwiperKiller(
					'album',
					{ xl: 1, lg: 1, md: 1, sm: 1, xs: 1 },
					{
						sliderIndex: sliderIndex,
						paddingWrapper: 0,
						infinite: true,
						autoplay: false,
						pagination: false,
					}
				);

				document.querySelectorAll('.control').forEach((btnNav) => {
					btnNav.setAttribute('aria-describedby', 'title-modal');
					btnNav.addEventListener('click', (e) => {});
				});
			} else {
				document.querySelector('[data-sk-index]').innerHTML = '1';
				document.querySelector('[data-sk-slide]').style.marginLeft = 0;
			}
		}, 500);
	};

	const nav = (root) => {
		document.querySelector('.album__close').focus();

		root.addEventListener('keydown', (e) => {
			if (e.key !== 'Tab' && e.key !== 'Enter') {
				return;
			}

			let lastFocusable;

			setTimeout(() => {
				lastFocusable = root.querySelectorAll(
					'button:not([tabindex="-1"]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
				);
				lastFocusable = lastFocusable[lastFocusable.length - 1];

				if (document.activeElement === lastFocusable) {
					lastFocusable.addEventListener('keydown', focusFirst);

					function focusFirst(e) {
						if (e.key !== 'Tab') {
							return;
						}
						e.preventDefault();
						document.querySelector('.album__close').focus();
						lastFocusable.removeEventListener(
							'keydown',
							focusFirst
						);
					}
				}
			}, 600);
		});
	};

	const slider = (btnTarget) => {
		document.querySelectorAll(btnTarget).forEach((btn) => {
			btn.addEventListener('click', (e) => {
				sliderFunctionCore(btn);
				nav(document.querySelector('.album__block'));
			});
		});
	};

	/**
	 *
	 * @description Corps de la page d'un album
	 */
	const displayGalleryContent = (btnTarget, id, statut) => {
		const btnGallery = document.querySelectorAll(btnTarget);
		btnGallery.forEach((btn) => {
			btn.addEventListener('click', () => {
				btnOpenGallery = btn;
				document.querySelector('body').classList.add('overflow-layout');
				const albumId = btn.getAttribute(id);
				const galleryId = btn.getAttribute('data-gallery-id');
				$get(`/phototheque/get/${albumId}?isPost=true`).then((data) => {
					document
						.querySelector('.layout-container')
						.insertAdjacentHTML(
							'beforebegin',
							`<div class="album" id="album-photo" role="dialog" aria-modal="true" aria-labelledby="title-modal" gallery-id="${galleryId}">
								<div role="document" class="album-wrapper">
									<div class="album__block">
										<div class="album__block__header">
											<div class="album__block__cta">
												<button class="album__close" data-close id="close-photo-button"><i data-icon="arrow"></i> ${buttonCloseText()}</button>
												<button class="album__close album__close--cross" data-close>
													<i data-icon="cross"></i>
													<span class="sr-only">Retour à la liste des médias</span>
												</button>
											</div>
											<div class="album__text">
												<h3 id="title-modal">${data.mediaData.title}</h3>
												${data.mediaData.description}
												<p>Cet album est composé de ${data.galleryDataCount} médias</p>
											</div>
										</div>
										<div class="slider-count hide-content">
											<div class="swiper-killer" data-sk>
												<p class="slider-container__count" aria-live="polite" aria-atomic="true".>
													<span data-sk-index>
														<span class="sr-only">médias</span>
													</span>/${data.galleryDataCount}
												</p>
												<div class="wrapper" data-sk-wrapper>
													<ul class="slides" data-sk-slides></ul>
												</div>
											</div>
										</div>
									</div>
									<div class="album__item row" id="album__item"></div>
								</div>
							</div>`
						);

					let mediaId = 0;

					data.galleryData.forEach((media) => {
						const gallery = document.querySelector('.album__item');
						const slider = document.querySelector(
							'.swiper-killer .wrapper .slides'
						);
						mediaId += 1;

						if (media.type === 'image') {
							gallery.insertAdjacentHTML(
								'beforeend',
								` <div class="album__item__photo" style="background-image: url('${media.url}');">
									<button class="album__item__photo__slider" data-photo-title="${media.title}" data-id="${mediaId}" aria-describedby="title-modal">
										<i data-icon="zoom"></i>
										<span class="sr-only">Carrousel</span>
									</button>
								</div>`
							);
							slider.insertAdjacentHTML(
								'beforeend',
								`<li class="slide" data-id="${mediaId}" data-sk-slide>
									<img class="slide__img" src=${media.url}" alt="${media.description}"></img>
									<div class="slide__description">
										<span>${media.description}</span>
									</div>
								</li>`
							);
							console.log(media);
						} else {
							gallery.insertAdjacentHTML(
								'beforeend',
								`<div class="album__item__photo" style="background-image: url('${media.thumbnail}');">
									<button class="player-media-button" data-video-description="${media.description}" data-video-url="${media.url}" data-video-id="${media.entity_id}" data-id="${media.id}" data-provider="${media.provider}" ><i data-icon="videotheque"></i>
									<span class="sr-only">${ModuloTS['Play video']} ${media.description}</span></button>
								</div>`
							);
							slider.insertAdjacentHTML(
								'beforeend',
								`<li class="slide" data-id="${mediaId}" data-sk-slide>
									<img class="slide__img slide__video" src=${media.thumbnail}></img>
									<div class="slide__description">
										<span>${media.description}</span>
									</div>
									<button class="player-media-button-square" data-video-url="${media.url}" data-video-id="${media.entity_id}" data-video-description="${media.description}"  data-id="${media.id}" data-provider="${media.provider}"><i data-icon="video"></i>
									<span class="sr-only">${ModuloTS['Play video']} ${media.description}</span>
									</button>
								</li>`
							);
						}
					});

					albumOff();

					// Si le statut est à 1 le button qui permet de lancer le slider se trouver dans l'album
					if (statut === 1) {
						slider(
							'.album__item__photo .album__item__photo__slider'
						);
						keyboardNavigation(
							document.querySelector('#album-photo')
						);
					}
					// Si le statut est à 2 le bouton qui permet de lancer le slider au bon index est celui d'un média dans la galerie
					else if (statut === 2) {
						sliderFunctionCore(btn);
						slider(
							'.album__item__photo .album__item__photo__slider'
						);
					}
					playerWindow('.player-media-button');
					showMorePhoto();
				});
			});
		});
	};

	// Éviter d'éventuelle conflit entre les buttons a sélectionner
	const buttons = ['.gallery__item', '.image-gallery .btn.btn-primary'];
	const choiceButtonAction = (buttons) => {
		for (let i = 0; i < buttons.length; ) {
			if (
				document.querySelectorAll(buttons[i]) !== undefined ||
				document.querySelectorAll(buttons[i]) !== null ||
				document.querySelectorAll(buttons[i]) !== ''
			) {
				displayGalleryContent(buttons[i], 'data-gallery-id', 1);
			}
			i++;
		}
	};

	// GO 🚀
	const init = () => {
		photosNumber('data-gallery-id');
		choiceButtonAction(buttons);
		displayGalleryContent(
			'div.media-image button[data-link-gallery]',
			'data-gallery-id',
			2
		);
	};

	setTimeout(() => {
		init();
	}, 500);
})();
